import { useCallback, useEffect, useState } from "react";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
const WEBSITE_URL = "/image_url";

export default function FetchCarouselContent(props) {
  const galleryTitle = "gallery-" + props.title;
  const [images] = useState([]);
  const [lastIndex, setLastIndex] = useState(0);
  const [imageObjects, setImageObjects] = useState([]);
  const [status] = useState("");
  const { username } = useAuth();

  const updateGallery = useCallback(async () => {
    const url = WEBSITE_URL + "/gallery";
    // console.log("Fetching gallery:", { title: galleryTitle, username });
  
    try {
      const response = await axios.get(url, {
        params: { title: galleryTitle, username },
      });
  
      // console.log("Raw response:", response.data);
  
      if (response.data && response.data.length > 0) {
        const images = response.data.map((item, idx) => ({
          url: item.url,
          public_id: item.public_id,
          sortOrder: item.sortOrder ?? idx, 
        }));
  
        // console.log("Images after mapping with sortOrder:", images);
  
        const lastIndex = Math.max(
          ...images.map((obj) => {
            const parts = obj.public_id.split("-");
            return parseInt(parts[parts.length - 1], 10) || 0;
          })
        );
  
        setLastIndex(lastIndex);
        setImageObjects(images);
      } else {
        console.log("No images found.");
      }
    } catch (err) {
      console.error("Failed to fetch gallery:", err);
    }
  }, [galleryTitle, username]);
  

  useEffect(() => {
    const update = async () => {
      await updateGallery(lastIndex, images, status);
    };
    update();
  }, [lastIndex, images, status, updateGallery]);

  useEffect(() => {
    const update = async () => {
      await updateGallery(lastIndex, images, status);
    };
    update();
  }, [updateGallery, images, lastIndex, status]);

  // const handleReload = async () => {
  //     await updateGallery();
  // }

  return (
    <div className="container">
      {imageObjects.length > 0 && (
        <GalleryCarousel imageObjects={imageObjects} />
      )}
    </div>
  );
}

const GalleryCarousel = ({ imageObjects }) => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  return (
    <div className="gallery-carousel-wrapper">
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={16}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop
        breakpoints={{
          768: {
            slidesPerView: 1, // Keep same behavior for desktop
          },
        }}
      >
        {isMobile
          ? imageObjects.map((img, idx) => (
              <SwiperSlide key={idx}>
                <div className="mobile-layout">
                  <div className="mobile-single-wrapper">
                    <img
                      src={img.url}
                      alt={`Mobile-${idx}`}
                      className="image-full"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))
          : groupImagesForSlides(imageObjects).map((group, index) => (
              <SwiperSlide key={index}>
                <div className="desktop-layout">
                  <div className="grid-layout-slide">
                    <div className="left-large">
                      <img
                        src={group[0]?.url}
                        alt="Main"
                        className="image-full"
                      />
                    </div>
                    <div className="right-small-grid">
                      {group.slice(1).map((img, idx) => (
                        <div key={idx} className="small-img-wrapper">
                          <img
                            src={img.url}
                            alt={`Small-${idx}`}
                            className="image-full"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};



// Helper to group images
const groupImagesForSlides = (images, groupSize = 5) => {
  const groups = [];
  for (let i = 0; i < images.length; i += groupSize) {
    groups.push(images.slice(i, i + groupSize));
  }
  return groups;
};
